import { BrandedScreen } from "@bfc-software/bfc-web-ui/ui/shared/branded-screen";

import styles from "./auth-container.module.css";

interface AuthContainerProps {
  children: React.ReactNode;
}

/**
 * The shell for the sign-in screens.
 *
 * Defers to BrandedScreen for the navy background, pattern and logo, so signing
 * in and choosing a product share one treatment rather than two that resemble
 * each other and drift.
 */
export default function AuthContainer({ children }: AuthContainerProps) {
  return (
    <BrandedScreen logo="lead">
      <div className={styles.children}>{children}</div>
    </BrandedScreen>
  );
}
